if (!customElements.get('featured-collection-tabs')) {
  class FeaturedCollectionTabs extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      this.sliderComponent = this.querySelector('slider-component');
      this.sliderContainer = this.querySelector(`[id="Slider-${this.sectionId}"]`);
      this.loadedCollections = new Set();
      
      // Mark first collection as loaded
      const firstTab = this.querySelector('.collection-tab.active');
      if (firstTab) {
        this.loadedCollections.add(firstTab.dataset.collectionHandle);
      }
      
      this.bindEvents();
    }
    
    bindEvents() {
      this.querySelectorAll('.collection-tab').forEach(tab => {
        tab.addEventListener('click', this.handleTabClick.bind(this));
      });
    }
    
  async handleTabClick(event) {
    const tab = event.currentTarget;
    
    // Skip if already active
    if (tab.classList.contains('active')) return;
    
    const collectionHandle = tab.dataset.collectionHandle;
    
    // Add waiting state
    tab.classList.add('waiting');
    
    try {
      await this.loadCollection(collectionHandle);
      this.updateActiveTab(tab);
      this.loadedCollections.add(collectionHandle);
    } catch (error) {
      console.error('Failed to load collection:', error);
      tab.classList.remove('waiting');
    }
  }
    
    async loadCollection(handle) {
      const url = `${window.location.origin}/collections/${handle}?section_id=${this.sectionId}`;
      const response = await fetch(url);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const html = await response.text();
      
      // Parse and extract slider content
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newSlider = doc.querySelector(`[id="Slider-${this.sectionId}"]`);
      
      if (!newSlider) {
        throw new Error('Slider content not found in response');
      }
      
      // Fade out current content
      this.sliderContainer.style.opacity = '0';
      
      // Wait for fade out
      await new Promise(resolve => setTimeout(resolve, 300));
      
      // Replace content with opacity 0
      this.sliderContainer.innerHTML = newSlider.innerHTML;
      this.sliderContainer.style.opacity = '0';
      
      // Re-initialize slider
      if (this.sliderComponent && typeof this.sliderComponent.resetPages === 'function') {
        this.sliderComponent.resetPages();
      }
      
      // Fade in new content with double RAF for smooth transition
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.sliderContainer.style.opacity = '1';
        });
      });
    }
    
  updateActiveTab(newTab) {
    this.querySelectorAll('.collection-tab').forEach(tab => {
      tab.classList.remove('active', 'waiting');
    });
    newTab.classList.add('active');
  }
  }

  customElements.define('featured-collection-tabs', FeaturedCollectionTabs);
}
